// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media (max-width: 1024px) {
  .col-sm-1 {
    width: 8.33%;
  }
  .col-sm-2 {
    width: 16.66%;
  }
  .col-sm-3 {
    width: 25%;
  }
  .col-sm-4 {
    width: 33.33%;
  }
  .col-sm-5 {
    width: 41.66%;
  }
  .col-sm-6 {
    width: 50%;
  }
  .col-sm-7 {
    width: 58.33%;
  }
  .col-sm-8 {
    width: 66.66%;
  }
  .col-sm-9 {
    width: 75%;
  }
  .col-sm-10 {
    width: 83.33%;
  }
  .col-sm-11 {
    width: 91.66%;
  }
  .col-sm-12 {
    width: 100%;
  }
  .col-sm-offset-1 {
    margin-left: 8.33%;
  }
  .col-sm-offset-2 {
    margin-left: 16.66%;
  }
  .col-sm-offset-3 {
    margin-left: 25%;
  }
  .col-sm-offset-4 {
    margin-left: 33.33%;
  }
  .col-sm-offset-5 {
    margin-left: 41.66%;
  }
  .col-sm-offset-6 {
    margin-left: 50%;
  }
  .col-sm-offset-7 {
    margin-left: 58.33%;
  }
  .col-sm-offset-8 {
    margin-left: 66.66%;
  }
  .col-sm-offset-9 {
    margin-left: 75%;
  }
  .col-sm-offset-10 {
    margin-left: 83.33%;
  }
  .col-sm-offset-11 {
    margin-left: 91.66%;
  }
  .col-sm-offset-12 {
    margin-left: 100%;
  }
}
@media (min-width: 1025px) {
  .col-md-1 {
    width: 8.33%;
  }
  .col-md-2 {
    width: 16.66%;
  }
  .col-md-3 {
    width: 25%;
  }
  .col-md-4 {
    width: 33.33%;
  }
  .col-md-5 {
    width: 41.66%;
  }
  .col-md-6 {
    width: 50%;
  }
  .col-md-7 {
    width: 58.33%;
  }
  .col-md-8 {
    width: 66.66%;
  }
  .col-md-9 {
    width: 75%;
  }
  .col-md-10 {
    width: 83.33%;
  }
  .col-md-11 {
    width: 91.66%;
  }
  .col-md-12 {
    width: 100%;
  }
  .col-md-offset-1 {
    margin-left: 8.33%;
  }
  .col-md-offset-2 {
    margin-left: 16.66%;
  }
  .col-md-offset-3 {
    margin-left: 25%;
  }
  .col-md-offset-4 {
    margin-left: 33.33%;
  }
  .col-md-offset-5 {
    margin-left: 41.66%;
  }
  .col-md-offset-6 {
    margin-left: 50%;
  }
  .col-md-offset-7 {
    margin-left: 58.33%;
  }
  .col-md-offset-8 {
    margin-left: 66.66%;
  }
  .col-md-offset-9 {
    margin-left: 75%;
  }
  .col-md-offset-10 {
    margin-left: 83.33%;
  }
  .col-md-offset-11 {
    margin-left: 91.66%;
  }
  .col-md-offset-12 {
    margin-left: 100%;
  }
}
.product-configurator {
  margin-bottom: 60px;
}

h1 {
  margin-bottom: 20px;
  margin-top: 30px;
}

h2 {
  margin: 15px 0;
}

h3 {
  font-size: 2.4rem;
}

section {
  font-weight: medium;
}

.lisence-container {
  border-radius: 8px;
  border-radius: 8px;
  border-radius: 8px;
  border-radius: 8px;
  border-radius: 8px;
  border: 1px solid #d2d2d2;
  margin: 20px 0;
  padding: 20px;
}
.lisence-container .qty-block {
  margin-top: 20px;
}
.lisence-container .already-own {
  margin-top: 0;
}
.lisence-container h3 {
  margin-bottom: 0;
}
.lisence-container .qty-error {
  margin-bottom: 0;
  margin-left: 15px;
}
.lisence-container span {
  font-size: 24px;
}
.lisence-container .margin-bot {
  margin-bottom: 8px;
}
.lisence-container .margin-top {
  margin-top: 8px;
}
.lisence-container .number-license {
  margin-top: 10px;
}
.lisence-container .price-value {
  font-size: 24px;
  margin-bottom: 5px;
  text-align: right;
}
.lisence-container .per-month {
  font-size: 14px;
  text-align: right;
}
.lisence-container .license {
  font-size: 1.6rem;
}

.padding-right {
  padding-right: 0;
}

.singeline {
  border-radius: 8px;
  border-radius: 8px;
  border-radius: 8px;
  border-radius: 8px;
  border-radius: 8px;
  border: 1px solid #d2d2d2;
  margin: 20px 0;
  padding: 20px;
}
.singeline .price-detail {
  display: block;
}
.singeline .price-detail .price-value {
  font-family: "Omnes-ATT-W02-Medium";
  font-size: 24px;
  margin-bottom: 5px;
  text-align: right;
}
.singeline .price-detail .price-value + p {
  margin-bottom: 0;
}
.singeline .price-detail .per-month {
  font-size: 14px;
  text-align: right;
}
.singeline.totalcontainer {
  background: hsl(150, 100%, 24%);
  border: 1px solid hsl(150, 100%, 24%);
  color: hsl(0, 0%, 95%);
}
.singeline.selected-row {
  border: 2px solid hsl(150, 100%, 24%);
}
.singeline hr {
  margin: 20px 80px 0 45px;
}

.btn-update {
  padding: 7px 18px 8px;
}

.cart-hr {
  margin: 30px 0;
}

.valign-children-middle {
  margin-top: 10px;
}

.mar-bot-20 {
  margin-bottom: 20px;
}

.custom-label {
  display: block;
  margin-bottom: 10px;
}

@media (max-width: 1024px) {
  .product-configurator {
    margin: 0 auto;
    margin-bottom: 30px;
  }
  h3 {
    font-size: 16px;
  }
  h1 {
    margin-bottom: 30px;
    margin-top: 20px;
  }
  .singeline .price-detail {
    display: inline-block;
    margin-top: 10px;
  }
  .singeline .price-detail .price-value {
    text-align: left;
  }
  .singeline .price-detail .price-value + p {
    margin-bottom: 10px;
  }
  .singeline .price-detail .per-month {
    text-align: left;
  }
  .singeline hr {
    margin: 20px 0 0;
  }
  .singeline.totalcontainer h3 {
    margin-bottom: 10px;
  }
  .btn {
    text-align: center;
  }
  .btn-cart {
    width: 100%;
  }
  .btn-update {
    width: 100%;
  }
  .btn-link {
    margin-top: 20px;
  }
  .add-quantity {
    margin-bottom: 20px;
  }
  .lisence-container .margin-top {
    margin: 20px 0;
  }
  .lisence-container .price-value,
  .lisence-container .per-month {
    text-align: left;
  }
  .lisence-container .volume {
    margin: 20px 0;
  }
  .lisence-container span {
    font-size: 16px;
  }
  .checkout-btn {
    margin-top: 20px;
  }
}`, "",{"version":3,"sources":["webpack://./src/lib/ng2-sapmp/src/assets/style/mixinfunction.scss","webpack://./src/lib/ng2-sapmp/src/assets/style/variables.scss","webpack://./src/app/pages/manage-product/modify-license/modify-license.component.scss"],"names":[],"mappings":"AAwBI;EA4BA;IACE,YClDE;ECAN;EFiDE;IACE,aClDE;ECGN;EF8CE;IACE,UClDE;ECMN;EF2CE;IACE,aClDE;ECSN;EFwCE;IACE,aClDE;ECYN;EFqCE;IACE,UClDE;ECeN;EFkCE;IACE,aClDE;ECkBN;EF+BE;IACE,aClDE;ECqBN;EF4BE;IACE,UClDE;ECwBN;EFyBE;IACE,aClDE;EC2BN;EFsBE;IACE,aClDE;EC8BN;EFmBE;IACE,WClDE;ECiCN;EFqBE;IACE,kBCvDE;ECoCN;EFkBE;IACE,mBCvDE;ECuCN;EFeE;IACE,gBCvDE;EC0CN;EFYE;IACE,mBCvDE;EC6CN;EFSE;IACE,mBCvDE;ECgDN;EFME;IACE,gBCvDE;ECmDN;EFGE;IACE,mBCvDE;ECsDN;EFAE;IACE,mBCvDE;ECyDN;EFHE;IACE,gBCvDE;EC4DN;EFNE;IACE,mBCvDE;EC+DN;EFTE;IACE,mBCvDE;ECkEN;EFZE;IACE,iBCvDE;ECqEN;AACF;AF7CI;EAoCA;IACE,YC9DE;EC0EN;EFbE;IACE,aC9DE;EC6EN;EFhBE;IACE,UC9DE;ECgFN;EFnBE;IACE,aC9DE;ECmFN;EFtBE;IACE,aC9DE;ECsFN;EFzBE;IACE,UC9DE;ECyFN;EF5BE;IACE,aC9DE;EC4FN;EF/BE;IACE,aC9DE;EC+FN;EFlCE;IACE,UC9DE;ECkGN;EFrCE;IACE,aC9DE;ECqGN;EFxCE;IACE,aC9DE;ECwGN;EF3CE;IACE,WC9DE;EC2GN;EFzCE;IACE,kBCnEE;EC8GN;EF5CE;IACE,mBCnEE;ECiHN;EF/CE;IACE,gBCnEE;ECoHN;EFlDE;IACE,mBCnEE;ECuHN;EFrDE;IACE,mBCnEE;EC0HN;EFxDE;IACE,gBCnEE;EC6HN;EF3DE;IACE,mBCnEE;ECgIN;EF9DE;IACE,mBCnEE;ECmIN;EFjEE;IACE,gBCnEE;ECsIN;EFpEE;IACE,mBCnEE;ECyIN;EFvEE;IACE,mBCnEE;EC4IN;EF1EE;IACE,iBCnEE;EC+IN;AACF;AA/IA;EACE,mBAAA;AAiJF;;AA9IA;EACE,mBAAA;EACA,gBAAA;AAiJF;;AA9IA;EACE,cAAA;AAiJF;;AA9IA;EACE,iBAAA;AAiJF;;AA9IA;EACE,mBAAA;AAiJF;;AA9IA;EFWI,kBAAA;EAAA,kBAAA;EAAA,kBAAA;EAAA,kBAAA;EAAA,kBAAA;EETF,yBAAA;EACA,cAAA;EACA,aAAA;AAqJF;AAnJE;EACE,gBAAA;AAqJJ;AAlJE;EACE,aAAA;AAoJJ;AAjJE;EACE,gBAAA;AAmJJ;AAhJE;EACE,gBAAA;EACA,iBAAA;AAkJJ;AA/IE;EACE,eAAA;AAiJJ;AA9IE;EACE,kBAAA;AAgJJ;AA7IE;EACE,eAAA;AA+IJ;AA5IE;EACE,gBAAA;AA8IJ;AA3IE;EACE,eAAA;EACA,kBAAA;EACA,iBAAA;AA6IJ;AA1IE;EACE,eAAA;EACA,iBAAA;AA4IJ;AAzIE;EACE,iBAAA;AA2IJ;;AAtIA;EACE,gBAAA;AAyIF;;AArIA;EFlDI,kBAAA;EAAA,kBAAA;EAAA,kBAAA;EAAA,kBAAA;EAAA,kBAAA;EEoDF,yBAAA;EACA,cAAA;EACA,aAAA;AA4IF;AA1IE;EACE,cAAA;AA4IJ;AA1II;EACE,mCAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;AA4IN;AA1IM;EACE,gBAAA;AA4IR;AAxII;EACE,eAAA;EACA,iBAAA;AA0IN;AAtIE;EACE,+BAAA;EACA,qCAAA;EACA,sBAAA;AAwIJ;AArIE;EACE,qCAAA;AAuIJ;AApIE;EACE,wBAAA;AAsIJ;;AAjIA;EACE,qBAAA;AAoIF;;AAjIA;EACE,cAAA;AAoIF;;AAjIA;EACE,gBAAA;AAoIF;;AAlIA;EACE,mBAAA;AAqIF;;AAnIA;EACE,cAAA;EACA,mBAAA;AAsIF;;AF9PI;EE6HF;IACE,cAAA;IACA,mBAAA;EAqIF;EAlIA;IACE,eAAA;EAoIF;EAjIA;IACE,mBAAA;IACA,gBAAA;EAmIF;EA/HE;IACE,qBAAA;IACA,gBAAA;EAiIJ;EA/HI;IACE,gBAAA;EAiIN;EA/HM;IACE,mBAAA;EAiIR;EA7HI;IACE,gBAAA;EA+HN;EA3HE;IACE,gBAAA;EA6HJ;EAzHI;IACE,mBAAA;EA2HN;EAtHA;IACE,kBAAA;EAwHF;EArHA;IACE,WAAA;EAuHF;EApHA;IACE,WAAA;EAsHF;EAnHA;IACE,gBAAA;EAqHF;EAlHA;IACE,mBAAA;EAoHF;EAhHE;IACE,cAAA;EAkHJ;EA/GE;;IAEE,gBAAA;EAiHJ;EA9GE;IACE,cAAA;EAgHJ;EA7GE;IACE,eAAA;EA+GJ;EA3GA;IACE,gBAAA;EA6GF;AACF","sourcesContent":["@import 'variables';\n\n@function color($color-name, $color-variant: null) {\n  // color variant is optional\n  @if ($color-variant != null) {\n    // map inception\n    @return map-get(map-get($colors, $color-name), $color-variant);\n  }@else {\n    @return map-get($colors, $color-name);\n  }\n}\n// buttons building section\n\n$btns: (\n  default: color(default, base),\n  primary: color(primary, base),\n  secondary:  color(secondary, base),\n  inverse: color(inverse, light),\n  success: color(success, base),\n  danger:  color(danger, base)\n);\n\n@mixin respond-to($breakpoint) {\n  @if $breakpoint == 'small' {\n    @media (max-width: 1024px) {\n      @content;\n    }\n  }@else if $breakpoint == 'large' {\n    @media (min-width: 1025px) {\n      @content;\n    }\n  }\n}\n\n@mixin vendor-prefix($name, $value) {\n  @each $vendor in ('-webkit-', '-moz-', '-ms-', '-o-', '') {\n    #{$name}: #{$value};\n  }\n}\n\n\n@mixin placeholder() {\n  color: color(inverse, light) !important;\n  font-family: 'Omnes-ATT-W02-Italic'!important;\n  font-style: normal;\n  opacity: 1;\n  font-size: 16px;\n}\n\n// dynamic\n@include respond-to(small) {\n  @each $gridname, $gridvalue in $grids {\n    .col-sm-#{$gridname} {\n      width: $gridvalue;\n    }\n  }\n  @each $gridname, $gridvalue in $grids {\n    .col-sm-offset-#{$gridname} {\n      margin-left: $gridvalue;\n    }\n  }\n}\n@include respond-to (large) {\n  @each $gridname, $gridvalue in $grids {\n    .col-md-#{$gridname} {\n      width: $gridvalue;\n    }\n  }\n  @each $gridname, $gridvalue in $grids {\n    .col-md-offset-#{$gridname} {\n      margin-left: $gridvalue;\n    }\n  }\n}\n","// Global Variables\n@import './../../../../../assets/style/var-config';\n// grids here\n$grids: (\n  1: 8.33%,\n  2: 16.66%,\n  3: 25%,\n  4: 33.33%,\n  5: 41.66%,\n  6: 50%,\n  7: 58.33%,\n  8: 66.66%,\n  9: 75%,\n  10: 83.33%,\n  11: 91.66%,\n  12: 100%\n);\n\n\n// refer http://digitaldesign.web.att.com/getstarted-color.html\n$att-dark-blue: hsl(205, 94%, 35%); // #0568ae\n$f-red: hsl(0, 66%, 49%); // #cf2a2a Functional Red\n$fb-gray: hsl(0, 0%, 95%); // #f2f2f2 Functional background Gray\n$att-dark-gray: hsl(0, 0%, 35%); // #5a5a5a\n$f-green: hsl(150, 100%, 24%); // #007a3e functional Green\n// $att-orange: hsl(30, 100%, 46%); // #ea7400 ATT Orange\n$att-orange: #ea7400; //ATT Orange\n\n// set color map easy use variables\n$primary: $att-orange !default;\n$secondary: $att-dark-blue !default;\n$default: $fb-gray !default;\n$inverse: $att-dark-gray !default;\n$danger: $f-red !default;\n$success: $f-green !default;\n\n\n// color variable map\n$colors: (\n  info: #009fdb,\n  enrolledActive:  #66cc00,\n  enrolledNotActive: #70c5e9,\n  notEnrolled: #fdb91d,\n  outOfCompliance: #cccccc,\n  appleNotinstalled: #fcbb15, \n\n  // Primary - Blue color\n  primary: (\n    base: $primary,\n    light: lighten($primary, 15%),\n    lightest: lighten($primary, 60%),\n    dark: darken($primary, 15%)\n  ),\n\n  // Secondary - Orange color\n  secondary: (\n    base: $secondary,\n    light: lighten($secondary, 15%),\n    lightest: lighten($secondary, 60%),\n    dark: darken($secondary, 15%)\n  ),\n\n  // default - Gray color\n  default: (\n    base: $default,\n    light: lighten($default, 5%), // #fff white\n    dark: darken($default, 12.8%), // #d2d2d2 ATT Light Gray\n    darker: darken($default, 18%) // #c4c4c4\n  ),\n\n  // Inverse - Black color\n  inverse: (\n    base: $inverse,\n    light: lighten($inverse, 11.25%), // #767676 Auxiliary Gray\n    lightest: lighten($inverse, 25%), // #999999\n    lighter: lighten($inverse, 23.4%), // #959595 ATT Gray\n    dark: darken($inverse, 15%), // #333 ATT Dark Gray (2015)\n    darker: darken($inverse, 25.2%), // #191919 Functional Digital Text Black\n    darkest: darken($inverse, 35%) // #000 \n  ),\n\n  // danger - Red color\n  danger: (\n    base: $danger,\n    light: lighten($danger, 15%),\n    dark: darken($danger, 15%)\n  ),\n\n  // success - Green color\n  success: (\n    base: $success,\n    light: lighten($success, 15%),\n    dark: darken($success, 15%)\n  )\n);\n","// Product configurator page component styling\n\n@import '../../../../lib/ng2-sapmp/src/assets/style/mixinfunction';\n\n.product-configurator {\n  margin-bottom: 60px;\n}\n\nh1 {\n  margin-bottom: 20px;\n  margin-top: 30px;\n}\n\nh2 {\n  margin: 15px 0;\n}\n\nh3 {\n  font-size: 2.4rem;\n}\n\nsection {\n  font-weight: medium;\n}\n\n.lisence-container {\n  @include vendor-prefix('border-radius', 8px);\n  border: 1px solid color(default, dark);\n  margin: 20px 0;\n  padding: 20px;\n\n  .qty-block {\n    margin-top: 20px;\n  }\n\n  .already-own {\n    margin-top: 0;\n  }\n\n  h3 {\n    margin-bottom: 0;\n  }\n\n  .qty-error {\n    margin-bottom: 0;\n    margin-left: 15px;\n  }\n\n  span {\n    font-size: 24px;\n  }\n\n  .margin-bot {\n    margin-bottom: 8px;\n  }\n\n  .margin-top {\n    margin-top: 8px;\n  }\n\n  .number-license {\n    margin-top: 10px;\n  }\n\n  .price-value {\n    font-size: 24px;\n    margin-bottom: 5px;\n    text-align: right;\n  }\n\n  .per-month {\n    font-size: 14px;\n    text-align: right;\n  }\n\n  .license {\n    font-size: 1.6rem;\n  }\n\n}\n\n.padding-right {\n  padding-right: 0;\n}\n\n\n.singeline {\n  @include vendor-prefix('border-radius', 8px);\n  border: 1px solid color(default, dark);\n  margin: 20px 0;\n  padding: 20px;\n\n  .price-detail {\n    display: block;\n\n    .price-value {\n      font-family: 'Omnes-ATT-W02-Medium';\n      font-size: 24px;\n      margin-bottom: 5px;\n      text-align: right;\n\n      & + p {\n        margin-bottom: 0;\n      }\n    }\n\n    .per-month {\n      font-size: 14px;\n      text-align: right;\n  }\n }\n\n  &.totalcontainer {\n    background: color(success, base);\n    border: 1px solid color(success, base);\n    color: color(default, base);\n  }\n\n  &.selected-row {\n    border: 2px solid color(success, base);\n  }\n\n  hr {\n    margin: 20px 80px 0 45px;\n  }\n}\n\n\n.btn-update {\n  padding: 7px 18px 8px;\n}\n\n.cart-hr {\n  margin: 30px 0;\n}\n\n.valign-children-middle {\n  margin-top: 10px;\n}\n.mar-bot-20 {\n  margin-bottom: 20px;\n}\n.custom-label {\n  display: block;\n  margin-bottom: 10px;\n}\n\n@include respond-to(small) {\n\n  .product-configurator {\n    margin: 0 auto;\n    margin-bottom: 30px;\n  }\n\n  h3 {\n    font-size: 16px;\n  }\n\n  h1 {\n    margin-bottom: 30px;\n    margin-top: 20px;\n  }\n\n  .singeline {\n    .price-detail {\n      display: inline-block;\n      margin-top: 10px;\n\n      .price-value {\n        text-align: left;\n\n        & + p {\n          margin-bottom: 10px;\n        }\n      }\n\n      .per-month {\n        text-align: left;\n    }\n    }\n\n    hr {\n      margin: 20px 0 0;\n   }\n\n    &.totalcontainer {\n      h3 {\n        margin-bottom: 10px;\n     }\n   }\n }\n\n  .btn {\n    text-align: center;\n  }\n\n  .btn-cart {\n    width: 100%;\n  }\n\n  .btn-update {\n    width: 100%;\n  }\n\n  .btn-link {\n    margin-top: 20px;\n  }\n\n  .add-quantity {\n    margin-bottom: 20px;\n  }\n\n  .lisence-container {\n    .margin-top {\n      margin: 20px 0;\n    }\n\n    .price-value,\n    .per-month {\n      text-align: left;\n    }\n\n    .volume {\n      margin: 20px 0;\n    }\n\n    span {\n      font-size: 16px;\n    }\n  }\n\n  .checkout-btn {\n    margin-top: 20px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
